module.exports = __webpack_public_path__ + "img/reset-password-inactive.b565ea5f.svg";